var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTicketWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 8.162a1.25 1.25 0 001-1.224V5a1.25 1.25 0 00-1.25-1.25h-15A1.25 1.25 0 001.25 5v1.938a1.25 1.25 0 001 1.224 1.875 1.875 0 010 3.672 1.25 1.25 0 00-1 1.228V15a1.25 1.25 0 001.25 1.25h15A1.25 1.25 0 0018.75 15v-1.938a1.25 1.25 0 00-1-1.224 1.875 1.875 0 010-3.672v-.004zm-15.25 4.9a3.125 3.125 0 000-6.124V5h4.375v10H2.5v-1.938z",
    fill: "#fff"
  })));
}

export default SvgTicketWhite;